import React from "react";
import { useTranslation } from "react-i18next";
import API_BASE from "../../../api";
import { isVideoMedia } from "../pastTripAnalytics";
import { Fish } from "lucide-react";

export default function PastTripSummaryGallery({
  items,
  onOpenMedia,
  onOpenInfo,
}) {
  const { t } = useTranslation();
  const getSourceLabel = (item) => {
    if (item.sourceType === "trip_catch") return t("trip_report_manual_catch");
    if (item.sourceType === "post") return t("trip_report_linked_post");
    return "";
  };

  return (
    <div className="mytrips-past-summary-section mytrips-past-summary-section--gallery">
      <h4 className="mytrips-past-summary-section-title">
        {t("trip_catch_gallery", {
          defaultValue: "Catch Gallery",
        })}
      </h4>

      {items.length > 0 ? (
        <div className="mytrips-past-gallery">
          {items.map((item) => {
            const hasMedia = Boolean(item.mediaUrl);
            const mediaSrc = hasMedia ? `${API_BASE}${item.mediaUrl}` : "";
            const video = hasMedia && isVideoMedia(item.mediaUrl);
            const sourceLabel = getSourceLabel(item);

            return (
              <div
                key={`gallery-${item.id}`}
                className={`mytrips-past-gallery-card${
                  hasMedia ? "" : " mytrips-past-gallery-card--no-media"
                }`}
              >
                {hasMedia ? (
                  <button
                    type="button"
                    className="mytrips-past-gallery-media"
                    onClick={() =>
                      onOpenMedia({
                        type: video ? "video" : "image",
                        src: mediaSrc,
                        alt: item.fish || t("post_media"),
                      })
                    }
                  >
                    {video ? (
                      <video
                        src={mediaSrc}
                        muted
                        playsInline
                        preload="metadata"
                        className="mytrips-past-gallery-thumb"
                      />
                    ) : (
                      <img
                        src={mediaSrc}
                        alt={item.fish || t("post_media")}
                        className="mytrips-past-gallery-thumb"
                      />
                    )}
                  </button>
                ) : (
                  <div className="mytrips-past-gallery-placeholder" aria-hidden="true">
                    <Fish size={28} strokeWidth={2.1} />
                  </div>
                )}

                <div className="mytrips-past-gallery-body">
                  {sourceLabel && (
                    <span className="mytrips-past-gallery-source">
                      {sourceLabel}
                    </span>
                  )}
                  <div className="mytrips-past-gallery-name">
                    {item.fish || t("trip_catch_unknown", { defaultValue: "Catch" })}
                  </div>
                  <div className="mytrips-past-gallery-meta">
                    {item.savedCatchDate || "\u2014"}
                    {item.savedCatchTime ? ` \u2022 ${item.savedCatchTime}` : ""}
                  </div>
                  {item.weight && (
                    <div className="mytrips-past-gallery-meta">{item.weight}</div>
                  )}
                  <div className="mytrips-past-gallery-actions">
                    <button
                      type="button"
                      className="mytrips-past-gallery-action"
                      onClick={() => onOpenInfo(item)}
                    >
                      {t("info", { defaultValue: "Info" })}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="mytrips-past-summary-empty">
          {t("trip_gallery_empty", {
            defaultValue: "No media available for this trip.",
          })}
        </p>
      )}
    </div>
  );
}
